
        import * as module0 from './controllers/contact_controller.js';import * as module1 from './controllers/example_controller.js';import * as module2 from './controllers/scroll_controller.js';import * as module3 from './controllers/slider_controller.js'
        const modules = {
            "./controllers/contact_controller.js": module0,
            "./controllers/example_controller.js": module1,
            "./controllers/scroll_controller.js": module2,
            "./controllers/slider_controller.js": module3,
        };
        export default modules;
      